import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { storage } from "../../../../services/firebase";

/**
 * Uploads a file to Firebase Storage and returns the download URL.
 * @param {File} file - The file object to upload
 * @param {string} userId - The user ID (shop owner)
 * @param {string} guestId - The guest/user's ID
 * @param {function} onProgress - Callback for progress updates
 * @returns {Promise<string>} - The download URL of the uploaded file
 */
export function uploadImageToFirebase(file, userId, guestId, onProgress) {
  const timestamp = Date.now();
  const rawName = (file && typeof file.name === 'string' && file.name.trim()) ? file.name : 'upload';
  const safeFileName = rawName.replace(/[^a-zA-Z0-9._-]/g, '_');
  // Use the chat-attachments path as defined in Firebase Storage rules
  const storageRef = ref(storage, `chat-attachments/${userId}/${guestId}/${timestamp}_${safeFileName}`);
  if (!(file.type && file.type.startsWith('image/'))) {
    throw new Error('File is not an image.');
  }
  if (file.size > 5 * 1024 * 1024) {
    throw new Error('File exceeds 5MB limit.');
  }
  return new Promise((resolve, reject) => {
    const uploadTask = uploadBytesResumable(storageRef, file, { contentType: file.type });
    uploadTask.on('state_changed', 
      (snapshot) => {
        if (onProgress) {
          const percent = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
          onProgress(percent);
        }
      }, 
      (error) => {
        reject(error);
      }, 
      async () => {
        const url = await getDownloadURL(uploadTask.snapshot.ref);
        resolve(url);
      }
    );
  });
}
